import type { LinkProps } from '@mui/material';
import { DisclaimerText } from '../MHM/MHMTypography';

export function ToggleForgotPasswordForm({ sx, children, ...rest }: LinkProps) {
  return (
    <DisclaimerText
      role="button"
      component="span"
      sx={{ cursor: 'pointer', ...sx }}
      {...rest}
    >
      {children}
    </DisclaimerText>
  );
}
